import React, { useRef } from 'react';
import Title from '../../atoms/title/title.js';
import Icon from '../../atoms/icon/icon.js';

const MenuItem = ({ title, icon, active = false, label }) => {
    const className = active ? "mbw-menu-item-active" : "mbw-menu-item";
    const itemRef = useRef(null);
    const renderMenuItemIcon = () => icon ? (React.createElement("div", { "data-testid": "mbw-menu-item-icon" },
        React.createElement(Icon, { className: "mbw-menu-item-icon", parentRef: itemRef }, icon))) : null;
    const renderMenuItemTitle = () => title ? (React.createElement("div", { "data-testid": "mbw-menu-item-title", className: "mbw-menu-item-title" },
        React.createElement(Title, { fontStyle: "heading-h6" }, title))) : null;
    return (React.createElement("div", { "data-testid": "mbw-menu-item", ref: itemRef, className: className },
        React.createElement("div", { className: "mbw-menu-item-icon-and-title" },
            renderMenuItemIcon(),
            renderMenuItemTitle()),
        label || null));
};

export { MenuItem as default };
//# sourceMappingURL=menu_item.js.map
